import { useState } from "react";
import { toast } from "sonner";
import { UserCog } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { useLang } from "../context/LangContext";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";

export function ProfileDialog() {
  const { t } = useLang();
  const { user, setUser } = useAuth();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: user?.name || "", phone: user?.phone || "" });
  const [busy, setBusy] = useState(false);

  const openDialog = () => {
    setForm({ name: user?.name || "", phone: user?.phone || "" });
    setOpen(true);
  };

  const save = async () => {
    setBusy(true);
    try {
      await api.patch("/profile", form);
      setUser({ ...user, ...form });
      toast.success(t("profile_saved"));
      setOpen(false);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button data-testid="open-profile-btn" variant="ghost" size="sm" onClick={openDialog} className="w-full justify-start text-slate-300 hover:text-white hover:bg-white/5">
        <UserCog className="w-4 h-4 mr-2" />{t("my_profile")}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-slate-900 border-white/10 max-w-sm" data-testid="profile-dialog">
          <DialogHeader>
            <DialogTitle>{t("my_profile")}</DialogTitle>
            <DialogDescription className="text-slate-400">{t("phone_hint")}</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div>
              <Label className="text-xs text-slate-400">{t("name")}</Label>
              <Input data-testid="profile-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 bg-white/5 border-white/10" />
            </div>
            <div>
              <Label className="text-xs text-slate-400">{t("phone")}</Label>
              <Input data-testid="profile-phone-input" placeholder="+243990000000" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1 bg-white/5 border-white/10" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)}>{t("cancel")}</Button>
            <Button data-testid="profile-save-btn" onClick={save} disabled={busy} className="bg-indigo-500 hover:bg-indigo-600">{busy ? "…" : t("save")}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
